import React, { useEffect, useRef } from 'react';

import { Spinner } from '@betterment/samba-react';
import { Box, Flex, Text } from '@betterment/style-closet-react';

import { AppCustomerContext } from './CustomerProvider';

interface Props {
  reloadCustomer: AppCustomerContext['refetch'];
  message: string;
}

const SignupPending: React.FC<React.PropsWithChildren<Props>> = ({ reloadCustomer, message }) => {
  const currentRef = useRef<NodeJS.Timeout>(undefined);

  useEffect(() => {
    currentRef.current = setInterval(reloadCustomer, 5000);

    return () => {
      if (currentRef.current) {
        clearInterval(currentRef.current);
      }
    };
  }, [reloadCustomer]);

  return (
    <Box display="flex" height="100vh">
      <Box position="relative" width="100%">
        <Flex className="LoadingSpinner-background" flexDirection="column" justifyContent="center" alignItems="center">
          <Box height="48px" mb={8}>
            <Spinner size="lg" variant="secondary" />
          </Box>
          <Box>
            <Text color="bmtGrey90" lineHeight="4">
              {message}
            </Text>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default SignupPending;
